import Framework, { BaseService } from '@greenville/framework';
import { AET_STORE_EVENTS } from '../common/Constants';

export default class StruggleStudentsService extends BaseService {
  constructor() {
    super(AET_STORE_EVENTS.STRUGGLE_STUDENTS_REQUESTED, 'struggleStudentsStatus');
  }

  // TODO:: remove this later
  handleEvent(eventName, eventData = {}) {
    const { courseId, assignmentId } = eventData;
    const marinClient = this.getClient('marin');
    return marinClient.get(
      `aet/courses/${courseId}/assignments/${assignmentId}/struggle-students`
    );
  }

  // eslint-disable-next-line class-methods-use-this
  handleResponse(response, eventData = {}) {
    const { assignmentId } = eventData;
    const students = response?.data?.items || [];

    Framework.getStoreRegistry().getStore('assignment').setStruggleStudents(assignmentId, students);
    Framework.getEventManager().publish(AET_STORE_EVENTS.STRUGGLE_STUDENTS_COMPLETED, students);
  }

  // eslint-disable-next-line class-methods-use-this
  handleError(error) {
    Framework.getEventManager().publish(AET_STORE_EVENTS.STRUGGLE_STUDENTS_FAILED, error);
  }
}
